<p-dialog
  [(visible)]="popup"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  (onHide)="close()"
  [style]="{ width: '30vw' }"
  [header]="
    type === 'email'
      ? ('epicrisis.send-email' | translate)
      : ('epicrisis.send-sms' | translate)
  "
>
  <div class="form-group">

    <!-- TEMPLATE SELECT (DISTANCED) -->
    <div *ngIf="distanced" class="mb-3">
      <ng-container *ngIf="!templatesLoading; else tplLoading">
        <p-dropdown appendTo="body" [options]="type === 'email' ? emailTemplates : smsTemplates" optionLabel="templateName"
          placeholder="Şablon Seç" [(ngModel)]="selectedTemplate" (onChange)="onTemplateChange($event.value)"
          [showClear]="true"></p-dropdown>
      </ng-container>
    
      <ng-template #tplLoading>
        <div class="d-flex align-items-center gap-2">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Yükleniyor...</span>
        </div>
      </ng-template>
    </div>

    <!-- TEMPLATE PREVIEW -->
    <div *ngIf="distanced && selectedTemplate" class="mb-3">
      <strong *ngIf="templatePreview?.title">
        {{ templatePreview?.title }}
      </strong>
      <div class="template-preview">
        <!-- {{ templatePreview?.content }} -->
       <textarea
        *ngIf="templatePreview"
        class="form-control"
        [(ngModel)]="templatePreview.content"
        [readonly]="true"
        [disabled]="true"
      ></textarea>
      </div>
    </div>

    <!-- DEFAULT VALUES -->
    <!-- <div *ngIf="defaultValues.length" class="chips-container mb-2">
      <div
        *ngFor="let value of defaultValues"
        class="email-chip"
        [class.selected]="selectedValues.includes(value)"
        (click)="toggleValue(value)"
      >
      </div>
    </div> -->

    <!-- CONTACT BASED VALUES (DISTANCED FALSE) -->
    <div *ngIf="!distanced" class="chips-container">
      <div
        *ngFor="let value of selectableValues"
        class="email-chip"
        [class.selected]="selectedValues.includes(value)"
        (click)="toggleValue(value)"
      >
        {{ value }}
      </div>
    </div>

    <div class="mt-2">
      {{ type === 'email' ? 'Gönderilecek Mail Adresleri' : 'Gönderilecek Telefonlar' }}
    </div>

    <!-- MANUAL INPUT -->
    <p-chips
      class="mt-3"
      [(ngModel)]="selectedValues"
      [allowDuplicate]="false"
      (onAdd)="handleChipAdd($event)"
    ></p-chips>
  </div>

  <ng-template pTemplate="footer">
    <button class="send-button" (click)="send()" [disabled]="templatesLoading">
      {{ 'common.send' | translate }}
    </button>
  </ng-template>
</p-dialog>
